import Navbar from "../../component/Navbar";
import Footer from "../../component/Footer";
import { Link } from "react-router-dom";

const Audio1 = () => {
  return (
    <div>
      <Navbar />
        <div className="text-black ml-20 mt-5">
          <Link to="/mainaudiopage">
            <button className="flex gap-1 px-4 py-2 rounded-xl w-fit"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
            </svg>
              Back
            </button>
          </Link>
        </div>
          <h1 className="text-[#314C1C] text-3xl text-center font-bold pt-5 ">
          BLISSFUL SOUNDS
          </h1>
        <div className="lg:items-center justify-center mx-20 my-5 px-10 py-7 bg-[#DCAE96] mb-10">
            <div className="w-full md:grid md:justify-center md:items-center md:place-content-center">     
              <Link to=""
              >
                <div>
                <img
                  src="https://res.cloudinary.com/djltdw88d/image/upload/v1700580258/thrive-audio-1-4/dpgiozcsvgnaufvz9cgw.png"
                  alt="audio-img"
                  className="w-full md:w-[400px] md:h-[250px] rounded-md text-center object-cover"
                />
                <audio controls src="https://res.cloudinary.com/djltdw88d/video/upload/v1701287338/audio1-4%20audios/flypcat6tas4klkg2idv.mp3" className="w-full md:w-[400px]">
              </audio>
                </div>
              </Link>
              
              <div className="flex flex-col lg:flex-row lg:gap-16 gap-4 px-4 py-5 justify-center">
                <Link
                  to="https://res.cloudinary.com/djltdw88d/video/upload/v1701287338/audio1-4%20audios/flypcat6tas4klkg2idv.mp3">
                  <button
                    className="flex justify-center items-center text-[whitesmoke] font-medium bg-[#314C1C] p-3 rounded-md border-none">
                    DOWNLOAD
                  </button>
                </Link>
              </div>
            </div>
        
          <section className="md:mt-5 content-center justify-center items-center place-content-center px-5">
            <div className="content-center justify-center items-center place-content-center">
              <p className="text-[#314C1C] text-md text-justify text-[20px]">
                Nature has a profound way of soothing our souls, and the ocean's
                tranquil sounds are among the most effective instruments in this
                symphony of tranquility. The rhythmic crashing of waves against
                the coastline carries with it a sense of constancy and
                predictability that lulls us into a state of relaxation. This
                repetitive pattern resonates with the human psyche, providing a
                comforting backdrop to escape the complexities of modern life.
                Soothing ocean sounds are a gentle reminder of the vastness of
                our planet, a reminder that there are places where the rhythm of
                life is slower, more harmonious.
              </p>
            </div>
          </section>
        </div>

      <Footer />
    </div>
  );
};

export default Audio1;
